import React, { useCallback, useState } from "react";
import { FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Button } from 'react-bootstrap';
import { useCollapse } from "react-collapsed";
import cx from 'classnames';
import withStyles from "isomorphic-style-loader/withStyles";

import Loader from "../../Loader/Loader";
import { normalizePromoCode } from "../../EditProfileForm/normalizePhone";

import messages from "../../../locale/jsonMessages";
import { validatePromoCodeData } from "../../../actions/siteadmin/PromoCode/managePromoCodeData";

import { CouponCodeTag } from "../../Common/Assets/SvgIconComponent/CommonSvgIcon";
import { DownArrowIcon } from "../../Common/Assets/SvgIconComponent/SideMenuIcons";

import cs from '../../../components/commonStyle.css';
import s from './PromoCode.css';
import showToaster from "../../../helpers/toasterMessages/showToaster";

function PromoCode({ intl: { formatMessage }, containerClass, promoCodeLoading, discount }) {

    const [promoCode, setPromoCode] = useState('');
    const [isExpanded, setIsExpanded] = useState(false)
    const dispatch = useDispatch();
    const handleInputChange = useCallback((event) => {
        const inputValue = normalizePromoCode(event?.target?.value);
        setPromoCode(inputValue);
    });

    const handlePromoCode = async () => {
        if (discount > 0) {
            return await showToaster({ messageId: 'promoCodeCalculation', toasterType: 'error' })
        } else {
            await dispatch(validatePromoCodeData(promoCode));
        }

    };

    const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

    return (
        <div className={containerClass}>
            <button {...getToggleProps({ onClick: () => setIsExpanded(prev => !prev) })} className={cx(s.promoCodeAccordionBtn, isExpanded && s.promoCodeAccordionOpen)}>
                <span><CouponCodeTag className={s.couponCodeTagSvg} />&nbsp;<FormattedMessage {...messages.haveCouponCode} /></span>
                <DownArrowIcon className={s.promoCodeDropDownIcon} />
            </button>

            <div {...getCollapseProps()}>
                <div className={s.promoCodeInputWrapper}>
                    <FormControl
                        type="text"
                        placeholder={formatMessage(messages.enterCode)}
                        value={promoCode}
                        onChange={handleInputChange}
                        autoFocus={true}
                        className={s.promoCodeInput}
                    />
                    <Loader
                        type={"button"}
                        buttonType={"button"}
                        className={cx(cs.btnPrimary, cs.flexShrinkNone, 'loaderButtonFlex')}
                        show={promoCodeLoading}
                        handleClick={handlePromoCode}
                        label={formatMessage(messages.apply)}
                    />
                </div>
            </div>
        </div>
    )
}


export default injectIntl(withStyles(cs, s)(PromoCode))
